import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import { isSameDay } from "date-fns";

import common from "../common.module.scss";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import LoginHeader from "../../../organisms/LoginHeader";
import {
  Context,
  fetchAssessment,
  submitExperience,
  assessmentListPath,
} from "../../../store/student";

import styles from "./AssessmentDescriptionPage.module.scss";

const AssessmentDescriptionPage = () => {
  const { dispatch, contextState } = React.useContext(Context);
  const currentAssessment = contextState.assessment;
  const [calling, peep] = useWaitApiCall(contextState);
  const history = useHistory();

  const currentTermNo = React.useMemo(() => {
    return contextState.student.max_term_no || 0;
  }, [contextState.student.max_term_no]);

  const hasSameDayAssessment = React.useMemo(() => {
    return isSameDay(new Date(currentAssessment.created_at), new Date());
  }, [currentAssessment]);

  const handleSubmitExperience = React.useCallback(() => {
    if (calling) return;

    dispatch(
      peep(
        submitExperience({
          experience_score_1: null,
          experience_score_2: null,
          experience_score_3: null,
          experience_score_4: null,
          experience_score_5: null,
          experience_score_6: null,
          experience_score_7: null,
          reasons: [],
          next_actions: [],
          term_no: currentTermNo + 1,
        }),
      ),
    );
  }, [calling, dispatch, peep, currentTermNo]);

  const handleCreateAndDirectToAssessment = React.useCallback(() => {
    handleSubmitExperience();
    history.push(assessmentListPath);
  }, [history, handleSubmitExperience]);

  const handleDirectToAssessment = React.useCallback(() => {
    history.push(assessmentListPath);
  }, [history]);

  useIonViewWillEnter(() => {
    dispatch(peep(fetchAssessment()));
  });

  return (
    <IonPage>
      <LoginHeader title="自己評価ツール" unreadNotiCount={0} />
      <IonContent className={common.wrapper}>
        <div className={clsx(common.container, styles.container)}>
          <p className={styles.title}>あなたの経験を記録してみましょう。</p>
          <p className={styles.desc}>
            あなたの素養を可視化し、将来に向けて必要なステップを考えるサポートをします。
          </p>
          <div className={styles.buttonWrapper}>
            {!hasSameDayAssessment && (
              <button onClick={handleCreateAndDirectToAssessment}>
                新しい記録
              </button>
            )}
            {currentTermNo > 0 && (
              <button onClick={handleDirectToAssessment}>
                第{currentTermNo}回目の編集
              </button>
            )}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default AssessmentDescriptionPage;
